import { render } from "./BorrowFeeTipDialog.vue?vue&type=template&id=2d5fccc6&scoped=true&ts=true"
import script from "./BorrowFeeTipDialog.vue?vue&type=script&lang=ts"
export * from "./BorrowFeeTipDialog.vue?vue&type=script&lang=ts"

import "./BorrowFeeTipDialog.vue?vue&type=style&index=0&id=2d5fccc6&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d5fccc6"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QSpace,QBtn});qInstall(script, 'directives', {ClosePopup});
